import 'jquery-validation/dist/jquery.validate';
import Message from '../components/Message';

export default (function (w, d) {
    'use strict';

    function VipPopup() {
        this.popup = d.querySelector('.vip-popup');
        if (this.popup !== null) {
            this.popup = this.popup.parentElement;
            this.closeButton = this.popup.querySelector('.close');
            this.form = this.popup.querySelector('#vip-form');
        }
        this.openButtons = d.querySelectorAll('.order-vip');
        this.init();
    }

    VipPopup.prototype.init = function () {
        this.initOpenCloseButtons();
        this.validateForm();
    }

    VipPopup.prototype.initOpenCloseButtons = function () {
        if (this.openButtons.length > 0) {
            this.openButtons.forEach(button => {
                button.addEventListener('click', () => {
                    this.popup.classList.toggle('hidden');
                });
            });

            this.closeButton.addEventListener('click', (e) => {
                e.preventDefault();
                this.popup.classList.toggle('hidden');
                $(this.popup).find('.c-form-input__error').removeClass('c-form-input__error')
            });
        }
    }

    VipPopup.prototype.validateForm = function () {
        let vipPopup = this;
        $('#vip-form').submit(function (event) {
            event.preventDefault();
            let form = $(this)
            form.find('.c-form-input__error').removeClass('c-form-input__error')
            $.ajax({
                url: $(form).attr('action'),
                method: 'post',
                headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                data: $(form).serialize(),
                success: function (response) {
                    if (response.status === 'success') {
                        new Message(response.message, 'success');
                        setTimeout(() => {
                            vipPopup.close()
                        }, 500);
                    }
                    $('.form-field input').val('');
                    $('.form-field textarea').val('');
                    grecaptcha.reset()
                },
                error: function (error) {
                    switch (error.status) {
                        case 500: {
                            new Message(error.statusText, 'error');
                        }
                            break;
                        case 422: {
                            let errorMessages = error.responseJSON.errors;
                            console.log('errorMessages', errorMessages);
                            for (const prop in errorMessages) {
                                new Message(errorMessages[prop][0], 'error');
                                form.find('#' + prop).addClass('c-form-input__error')
                            }
                        }
                            break;
                    }
                    grecaptcha.reset()
                }
            });

            return false;
        });
    }

    VipPopup.prototype.close = function () {
        this.popup.classList.toggle('hidden');
    }

    return VipPopup;
}(window, document));

